import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { MdSpaceDashboard } from 'react-icons/md';
import { AiOutlineHistory } from 'react-icons/ai';
import { BiLogOut } from 'react-icons/bi';

const menuList = [
    {
        icon: <MdSpaceDashboard />,
        title: "Dashboard",
        link: "/dashboard"
    },
    {
        icon: <AiOutlineHistory />,
        title: "Views Log",
        link: "/viewsLog"
    }
]

function SideBar() {
    const navigate = useNavigate();
    const logoutHandler = () => {
        window.sessionStorage.clear('isLoggedIn');
        window.sessionStorage.clear('business');
        navigate('/');

    }
    return (
        <aside className='side-bar'>
            <div className='content'>
                <div className='logo d-flex align-items-center justify-content-start border-bottom pb-3'>
                    <img src='./images/logo.png' className='me-2' width={35} />
                    <p className='mb-0 h6'>Total Home App</p>
                </div>
                <div className='nav-list-container'>
                    <ul>
                        {
                            menuList.map((item, index) => {
                                return (
                                    <li key={index}>

                                        <Link to={item.link} className='btn d-block w-full' style={{ color: "white" }}>
                                            <div className='d-flex gap-2 '>
                                                <span className="text-white">{item.icon}</span>
                                                <span className="text-white">{item.title}</span>
                                            </div>
                                        </Link>
                                    </li>
                                )
                            })
                        }
                        <li>
                            <button className='btn d-block w-full'  onClick={logoutHandler}>
                                <div className='d-flex gap-2'>
                                <span className="text-white">
                                    <BiLogOut />
                                </span>
                                <span className='text-white'>Log out</span>
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </aside>
    )
}

export default SideBar
